import { getBetTitleYourBetProps, getBetStatusLabelProps, getSelectionTitlesListProps, getBonusDetailsListProps, getTotalReturnProps, getBetSummaryProps, isBonusAvailable } from "../bet";
import { getEventDetailsProps } from "../selection";
export const getYourBetProps = (bet, state) => {
    let yourBetProps = {
        betTitle: getBetTitleYourBetProps(bet, state),
        betStatusLabel: getBetStatusLabelProps(bet, state),
        selectionTitlesList: getSelectionTitlesListProps(bet, state),
        totalReturn: getTotalReturnProps(bet, state),
        eventDetails: getEventDetailsProps(bet.type, bet.selections[0], state),
        betSummary: getBetSummaryProps(bet, state),
    };
    if (isBonusAvailable(bet)) {
        yourBetProps.bonusDetailsList = getBonusDetailsListProps(bet, state);
    }
    return yourBetProps;
};
//# sourceMappingURL=getYourBetProps.js.map